import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useApiClient } from '../../../hooks/useApiClient'
import { FloatingButtonIcon } from '../../../assets/icons'
import { Button } from '../../baseComponents'
import { myAccountContext, pathContext } from '../../../contexts/contexts'
import '../TermsOfUse/termsofuse.css'
import './CreateAccountTos.css'
import PageTitleHook from '../../../utils/PageTitleHook/PageTitleHook'
import { acknowledgmentAgreement, changesToTermsOfUse, governingLaws, linksToOtherWebSites, purpose, rulesOfBehavior, terminationHeader, terminationOfAccess, tradeMarksAndLogos } from '../../../constants/TermsOfUseBullets'
import { headerSection, createOrderSublist, createCustomListItems } from '../../../utils/helperListFunctions/listHelper'


const CreateAccountTos = () => {
  PageTitleHook('USCIS Online Account | Legal')
  const { setUrl } = useContext(pathContext)
  const { setUser } = useContext(myAccountContext)
  const scrollArrowRef = useRef<HTMLDivElement>(null)
  const agreeButtonRef = useRef<HTMLButtonElement>(null)
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const [showBtn, setShowBtn] = useState<boolean>(true)
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState<boolean>(false)
  const apiClient = useApiClient()
  let scrollingInterval: any = setInterval(() => {})

  const handleSubmit = (e: any) => {
    const url = window.location.origin + '/v1/users/accept_terms'
    setSubmitButtonDisabled(true);
    apiClient
      .post(url)
      .then((res) => {
        if (res.status === 200) {
          setUser(res.data);
          if (res.data['authentication_state'] === 'awaiting_password_creation') {
            setUrl('/create-password')
          }
          if (res.data['authentication_state'] === 'fully_signed_in') {
            setUrl('/dashboard')
          }
        }
      })
      .catch((err) => {
        console.log(err.response)
      });
  };

  const handleKeyDown = (e: any) => {
    if (e.repeat) return;
    if (e.key === 'Enter' || e.key === ' ') {
      scrollingInterval = setInterval(scrollDown, 100);
    }
  }

  const handleKeyUp = (e: any) => {
    if (e.key === 'Enter' || e.key === ' ') {
      stopScroll();
    }
  }

  const startScrollDown = () => {
    scrollingInterval = setInterval(scrollDown, 100);
  }

  const scrollDown = () => {
    if (isBottom(document.getElementById('container'))) {
      stopScroll();
    } else {
      window.scrollBy({
        top: 100,
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  const stopScroll = () => {
    clearInterval(scrollingInterval);
  }

  const isBottom = (el: HTMLElement | null) => {
    return el ? el.getBoundingClientRect().bottom <= window.innerHeight : false;
  }

  const trackScrolling = useCallback(() => {
    const wrappedElement = document.getElementById('container');
    if (isBottom(wrappedElement)) {
      setShowBtn(false)
    } else {
      setShowBtn(true)
    }
  }, [])

  const handleClickPageDown = () => {
    window.scrollBy({
      top: 100,
      left: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling)
    return () => window.removeEventListener('scroll', trackScrolling)
  }, [trackScrolling])


  return (
    <div id="container" className="card" ref={scrollContainerRef} data-testid="create-account-tos-container">
      <div>
        {showBtn && (
          <div ref={scrollArrowRef} data-testid="scroll-btn-container" className="relative" tabIndex={0}>
            <div className="absolute right-10 sm:right-4 top-96 z-10">
              <button
                data-testid="test-scroll-btn"
                aria-label="Scroll Button"
                className="fixed"
                onClick={handleClickPageDown}
                onMouseDown={startScrollDown}
                onMouseUp={stopScroll}
                onMouseOut={stopScroll}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyUp}
              >
                <FloatingButtonIcon />
              </button>
            </div>
          </div>
        )}
        <h1 className="text-3xl">Terms of Use</h1>

        <h2 className="terms-heading text-2xl text-dhs-blue" id="tos-tos">
          U.S. Citizenship and Immigration Services Online Electronic Immigration System
        </h2>
        <ol  className="tos-ol terms-of-use-ol p-0">
            {headerSection(<h3>Purpose</h3>)}
            {createOrderSublist(<>{createCustomListItems(purpose, )}</>)}
            {headerSection(<h3>Governing Laws</h3>)}
            {createOrderSublist(<>{createCustomListItems(governingLaws)}</>)}
            {headerSection(<h3>Trademarks and Logos</h3>)}
            {createOrderSublist(<>{createCustomListItems(tradeMarksAndLogos)}</>)}
            {headerSection(<h3>Rules of Behavior</h3>)}
            {createOrderSublist(<>{createCustomListItems(rulesOfBehavior)}</>)}
            {headerSection(terminationHeader)}
            {createOrderSublist(<>{createCustomListItems(terminationOfAccess)}</>)}
            {headerSection(<h3>Links to Other Web Sites</h3>)}
            {createOrderSublist(<>{createCustomListItems(linksToOtherWebSites)}</>)}
            {headerSection(<h3>Changes to Terms of Use</h3>)}
            {createOrderSublist(<>{createCustomListItems(changesToTermsOfUse)}</>)}
            {headerSection(<h3>Acknowledgment</h3>)}
            {createOrderSublist(createCustomListItems(acknowledgmentAgreement))}
        </ol>
      </div>

      <div className="button-container">
        <Button
          id="terms-submit-btn"
          data-testid="test-terms-submit-btn"
          text="I Agree"
          type="primary"
          className="mt-4"
          ref={agreeButtonRef}
          onClick={handleSubmit}
          disabled={submitButtonDisabled}
        />
      </div>
    </div>
  )
}

export default CreateAccountTos
